import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './Divider.module.scss';

const Divider = ({ className = '', style = {} }) => (
  <div
    className={classNames(styles.main, className)}
    style={{ ...style }}
  />
);

Divider.propTypes = {
  style: PropTypes.object,
  className: PropTypes.string,
};

export default Divider;
